/* eslint-disable max-len */
/* eslint-disable no-use-before-define */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-param-reassign */
import React, { useEffect, useRef, useState } from 'react';
import {
  Table,
  Row,
  Button,
  Input,
  Popover,
  Select,
  Typography,
  Grid,
  Tooltip,
} from 'antd';
import {
  SaveOutlined,
  EditOutlined,
  SearchOutlined,
  CloseOutlined,
  TableOutlined,
  ArrowLeftOutlined,
  DownOutlined,
  RightOutlined,
  CloseCircleFilled,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
// import HTTP, { baseURL } from 'utils/api';
// import { onError, onSuccess } from 'utils/handlers';
// import Dragger from 'components/Dragger';
// import FormSubmitControls from 'components/FormSubmitControls';
import Pagination from 'components/Pagination';

const { Option } = Select;
const { Text } = Typography;

const EditableTable = ({
  cols,
  mobileCols: _mobileCols,
  data,
  rowSelection,
  onRow: _onRow,
  editText,
  finishText,
  cancelText,
  noControls,
  controls,
  allowEdit,
  allowFinish,
  allowSearch,
  allowCancel,
  expandable: _expandable,
  filterNested,
  childrenProp,
  RTLHead,
  rowKey,
  handleOnRowClick,
  pageSize,
  disabled,
  allowColumnSelector,
  indentSize,
  loading: tableLoading,
  permission,
  hasAllViewPermission: _hasAllViewPermission,
  pagination,
  paginationCallback,
  count,
  currentPage,
  summaryCells,
  summaryColumnPosition,
}) => {
  rowKey = _expandable || childrenProp || filterNested ? 'key' : 'id';
  childrenProp = filterNested ? 'children' : null;
  const screens = Grid.useBreakpoint();
  const mobileCols = _mobileCols.length ? _mobileCols : [cols[0]];
  const [open, setVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [tableHeight, setTableheight] = useState(window.innerHeight - 430);
  const [lastDataSource, setLastDataSource] = useState([]);
  const [focusedInput, setFocusedInput] = useState();
  const [filters, setFilters] = useState([...cols
    .map((col) => ({ prop: col.dataIndex, value: null }))]);
  const [scrollX, setScrollX] = useState(0);
  const [visibleSarch, setVisibleSearch] = useState(false);
  const [componentKey, setComponentKey] = useState();

  // normalize/validate params
  allowEdit = allowEdit && !!controls?.onClickEdit;
  allowFinish = allowFinish && !!controls?.onClickFinish;
  allowCancel = allowCancel && !!controls?.onClickCancel;

  const ref = useRef();
  const [page, setPage] = useState(1);
  const [q, setQ] = useState();

  let expandable = null;

  if (!_expandable && childrenProp) {
    expandable = {
      expandRowByClick: true,
      childrenColumnName: childrenProp,
      indentSize,
      expandIcon: ({ expanded, onExpand, record }) => (record[childrenProp] && (
        expanded ? (
          <DownOutlined onClick={(e) => onExpand(record, e)} />
        ) : (
          <RightOutlined onClick={(e) => onExpand(record, e)} />
        )
      )),
    };
  }

  const onRow = _onRow || ((record) => ({
    onClick: () => {
      if (_expandable && !_expandable.expandRowByClick) {
        _expandable.expandRowByClick = true;
      }
      if (handleOnRowClick) {
        handleOnRowClick(record);
      }
    },
    // onDoubleClick: () => {
    //   if (controls?.onClickEdit && permission?.change) {
    //     controls.onClickEdit();
    //   }
    //   if (controls?.onClickExpand) {
    //     controls.onClickExpand();
    //   }
    //   if (controls?.onClickConfig && permission?.change) {
    //     controls.onClickConfig();
    //   }
    // },
  }));

  let filtNested = [];

  const filter = (array, fn) => array.reduce((r, o) => {
    const children = filter(o[childrenProp] || [], fn);
    if (fn(o) || children.length) {
      r.push({ ...o });
      if (!o[childrenProp]) {
        filtNested.push({ ...o });
      }
    }
    return r;
  }, []);

  const filterNestedData = () => {
    const dataClone = [...data];
    const filterList = filters.filter((item) => !!item.value);
    filtNested = [];
    if (filterList.length) {
      filterList.forEach(({ prop, value }) => {
        filter(dataClone, (i) => (i[prop] || '').toString().toLowerCase().includes(value));
      });
    }
    if (filtNested.length) {
      setDataSource(filtNested);
    } else {
      setDataSource(data);
    }
  };

  useEffect(() => {
    if (focusedInput && (!dataSource.length || (!lastDataSource.length && dataSource.length))) {
      const input = document.getElementById(focusedInput);
      setTimeout(() => {
        input.focus();
      });
    }
    // eslint-disable-next-line
  }, [dataSource]);

  useEffect(() => {
    if (filterNested) {
      filterNestedData();
      filterData();
    } else {
      filterData();
    }
    // eslint-disable-next-line
  }, [filters]);

  useEffect(() => {
    if (page !== currentPage) {
      setPage(currentPage);
    }
    // eslint-disable-next-line
  }, [currentPage]);

  const setFilter = (prop, value) => {
    let filtersClone = [...filters];
    filtersClone = filtersClone.filter((elem) => elem.prop !== prop);
    filtersClone.push({ prop, value });
    setFilters(filtersClone);
    if (paginationCallback && !pagination) {
      clearTimeout(ref.current);
      const entries = filtersClone.map((e) => [e.prop, e.value]);
      const _q = Object.fromEntries(entries);
      setQ(_q);
      ref.current = setTimeout(() => paginationCallback(page, _q), 2000);
      setPage(1);
    }
  };

  let timeoutSearch;

  const getTitle = (title, prop) => {
    const Icon = () => (filters.find((a) => a.prop === prop)?.value
      ? <CloseOutlined onClick={() => setFilter(prop, null)} /> : <SearchOutlined />);
    return (
      <>
        <Row>
          <span className={RTLHead ? 'head headRight' : 'head'}>
            {title}
          </span>
        </Row>
        {(allowSearch && visibleSarch) && (
          <Row>
            <Input
              id={`input-${prop}`}
              placeholder=""
              // value={filters.find((a) => a.prop === prop).value}
              onChange={(e) => {
                const value = e?.target?.value;
                if (timeoutSearch) {
                  clearTimeout(timeoutSearch);
                }
                timeoutSearch = setTimeout(() => {
                  setFilter(prop, value);
                });
              }}
              onFocus={() => setFocusedInput(`input-${prop}`)}
            />
            <Icon />
          </Row>
        )}
      </>
    );
  };

  useEffect(() => {
    const updateTableHeight = () => {
      setTableheight(window.innerHeight - 430);
    };
    updateTableHeight();
    const key = new Date().getTime();
    setComponentKey(`${key}_table`);
    window.addEventListener('resize', updateTableHeight);
    return () => window.removeEventListener('resize', updateTableHeight);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setDataSource(data);
    // eslint-disable-next-line
  }, [data]);

  const mobileColumns = mobileCols?.length > 1
    ? mobileCols.map((c) => ({
      ...c, key: c.dataIndex, title: c.titleText, width: c.width,
    }))
    : mobileCols.map((c) => ({
      ...c, key: c.dataIndex, title: c.titleText, width: '100%',
    }));

  const [selectedCols, setSelectedCols] = useState(cols.map(({ dataIndex }) => dataIndex));

  const columns = cols.map((col) => ({
    ...col,
    key: col.dataIndex,
    title: getTitle(col.titleText, col.key),
  }));

  const filterData = () => {
    setLastDataSource(dataSource);
    const dataClone = filtNested.length ? [...filtNested] : [...data];
    let filtered = dataClone;
    const filterList = filters.filter((item) => !!item.value);
    if (filterList.length) {
      filterList.forEach(({ prop, value }) => {
        filtered = filtered.filter((item) => {
          if (item[prop] && item[prop] !== null) {
            const col = columns.find((e) => e.key === prop);
            return (col?.render?.(item[prop]) || item[prop])
              .toString().toLowerCase().includes(value);
          }
          return false;
        });
      });
    }
    setDataSource(filtered);
  };

  useEffect(() => {
    if (filterNested) {
      filterNestedData();
      filterData();
    } else {
      filterData();
    }
    // eslint-disable-next-line
  }, [filters]);

  useEffect(() => {
    const filtered = columns.filter((col) => col.width && selectedCols.includes(col.key));
    const sum = filtered.reduce((prev, next) => prev + next.width, 0);
    setScrollX(sum);
    // eslint-disable-next-line
  }, [selectedCols]);

  const content = () => {
    const options = columns.map(({ key, titleText }) => ({
      key,
      text: titleText,
    }));
    return (
      <div style={{ maxWidth: 350 }}>
        <Text>
          Seleccione las columnas que desea mostrar
        </Text>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          value={selectedCols}
          onChange={(val) => {
            if (val.length >= 1) {
              setSelectedCols(val);
            }
          }}
        >
          {options.map((o) => (
            <Option value={o.value} key={o.key}>
              {o.text}
            </Option>
          ))}
        </Select>
      </div>
    );
  };

  const hasAllViewPermission = _hasAllViewPermission
    || permission?.hasAllViewPermission || !permission;

  const ButtonWrapper = ({
    children,
    hasPermission,
    edit,
  }) => {
    if (hasPermission && hasAllViewPermission) {
      const needKey = edit;
      if ((needKey && rowSelection?.selectedRowKeys.length) || !needKey) {
        return children;
      }
      return (
        <Tooltip title="Seleccione un elemento para realizar esta acción">
          {children}
        </Tooltip>
      );
    }

    return (
      <Tooltip title="No tienes los permisos necesarios para realizar esta acción">
        {children}
      </Tooltip>
    );
  };

  ButtonWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    hasPermission: PropTypes.bool,
    edit: PropTypes.bool,
  };

  ButtonWrapper.defaultProps = {
    hasPermission: false,
    edit: false,
  };

  const TableControls = () => (
    <Row
      align="middle"
      justify="space-between"
      style={{ paddingBottom: 10 }}
      className="table-controls"
    >
      <div>
        {(allowColumnSelector && screens.md) && (
          <Popover
            open={open}
            placement="bottomRight"
            content={content}
            title={(
              <Row
                align="middle"
                justify="space-between"
              >
                <Text className="title">
                  Selector de columnas
                </Text>
                <Button type="link" onClick={() => setVisible(false)}>
                  <ArrowLeftOutlined />
                  Cancelar
                </Button>
              </Row>
            )}
            trigger="click"
          >
            <Button type="link" onClick={() => setVisible(true)}>
              <TableOutlined />
              Selector de columnas
            </Button>
          </Popover>
        )}
      </div>
      <div style={{ marginLeft: 'auto' }}>
        {allowCancel && (
          <ButtonWrapper hasPermission={permission?.change} edit>
            <Button
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys.length || !permission?.change}
              onClick={() => controls.onClickCancel()}
              type="link"
            >
              <CloseCircleFilled />
              {screens.md && cancelText}
            </Button>
          </ButtonWrapper>
        )}
        {allowFinish && (
          <ButtonWrapper hasPermission={permission?.change} edit>
            <Button
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys.length || !permission?.change}
              onClick={() => controls.onClickFinish()}
              type="link"
            >
              <SaveOutlined />
              {screens.md && finishText}
            </Button>
          </ButtonWrapper>
        )}
        {allowEdit && (
          <ButtonWrapper hasPermission={permission?.change} edit>
            <Button
              disabled={!hasAllViewPermission
                || !rowSelection?.selectedRowKeys.length || !permission?.change}
              onClick={() => controls.onClickEdit()}
              type="link"
            >
              <EditOutlined />
              {screens.md && editText}
            </Button>
          </ButtonWrapper>
        )}
        {allowSearch && (
          <Button
            onClick={() => setVisibleSearch(!visibleSarch)}
            type="link"
          >
            <SearchOutlined />
            {screens.md && 'Búsquedas'}
          </Button>
        )}
      </div>
    </Row>
  );

  // const rules = {
  //   required: [
  //     {
  //       required: true,
  //       message: 'El campo es requerido',
  //     },
  //   ],
  // };

  const locale = {
    emptyText: hasAllViewPermission
      ? 'No hay datos' : 'Hacen falta permisos en los catálogos relacionados a este módulo',
  };

  const _dataSource = hasAllViewPermission ? dataSource : [];

  if (screens.md || !mobileColumns || mobileColumns.length > 1 || expandable) {
    return (
      <React.Fragment key={componentKey}>
        {(!noControls && !disabled) && (<TableControls />)}
        <Table
          size="small"
          columns={columns.filter((col) => selectedCols.includes(col.key))}
          dataSource={_dataSource}
          pagination={pagination && {
            position: ['bottomLeft'],
            pageSize,
          }}
          scroll={{
            y: tableHeight,
            x: !Number.isNaN(scrollX) ? scrollX : 0,
            scrollToFirstRowOnChange: true,
          }}
          rowSelection={disabled ? null : rowSelection}
          expandable={expandable}
          onRow={disabled ? null : onRow}
          className={`custom-table ${rowSelection && !disabled ? 'selectable' : ''}`}
          rowKey={rowKey}
          loading={tableLoading}
          locale={locale}
          summary={summaryCells && _dataSource?.length ? (
            (pageData) => {
              const mappedCells = summaryCells?.map((cell) => {
                const value = cell.calculateValue ? cell.calculateValue(pageData) : cell.value;
                return (
                  <>
                    {cell.label ? (
                      <Table.Summary.Cell align={cell.labelAlign} colSpan={cell.labelColSpan || 1}>
                        {cell.label}
                      </Table.Summary.Cell>
                    ) : null}
                    {summaryColumnPosition >= 2 ? (
                      <Table.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                        {summaryColumnPosition === 2 ? cell.render(value) : null}
                      </Table.Summary.Cell>
                    ) : null}
                    {summaryColumnPosition >= 3 ? (
                      <Table.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                        {summaryColumnPosition === 3 ? cell.render(value) : null}
                      </Table.Summary.Cell>
                    ) : null}
                    {summaryColumnPosition >= 4 ? (
                      <Table.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                        {summaryColumnPosition === 4 ? cell.render(value) : null}
                      </Table.Summary.Cell>
                    ) : null}
                    {summaryColumnPosition >= 5 ? (
                      <Table.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                        {summaryColumnPosition === 5 ? cell.render(value) : null}
                      </Table.Summary.Cell>
                    ) : null}
                  </>
                );
              });

              return (
                <Table.Summary.Row>
                  {rowSelection && !disabled ? <Table.Summary.Cell /> : null}
                  {mappedCells}
                </Table.Summary.Row>
              );
            }
          ) : null}
        />
        {(!pagination && count > 1) && (
          <Pagination
            page={page}
            setPage={setPage}
            callback={paginationCallback}
            count={count}
            q={q}
          />
        )}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment key={componentKey}>
      {(!noControls && !disabled) && (<TableControls />)}
      <Table
        size="small"
        columns={mobileColumns}
        dataSource={_dataSource}
        pagination={pagination && {
          position: ['bottomLeft'],
        }}
        scroll={{ y: tableHeight, scrollToFirstRowOnChange: true }}
        rowSelection={disabled ? null : rowSelection}
        onRow={onRow}
        expandRowByClick
        className={`custom-table expandable-responsive-table ${rowSelection && disabled ? 'selectable' : ''}`}
        expandable={{
          expandedRowRender: (record) => cols
            .filter((c) => !c.hide)
            .map((column) => (
              <Row
                key={column.dataIndex}
                justify="space-between"
              >
                <b>
                  {`${column.titleText}:`}
                </b>
                <span>
                  {column.render
                    ? column.render(record[column.dataIndex], record)
                    : record[column.dataIndex]}
                </span>
              </Row>
            )),
          expandIcon: ({ expanded, onExpand, record }) => (record && (
            expanded ? (
              <DownOutlined onClick={(e) => {
                e.stopPropagation();
                onExpand(record, e);
              }}
              />
            ) : (
              <RightOutlined onClick={(e) => {
                e.stopPropagation();
                onExpand(record, e);
              }}
              />
            )
          )),
        }}
        rowKey={rowKey}
        loading={tableLoading}
        locale={locale}
        summary={summaryCells && _dataSource?.length ? (
          (pageData) => {
            const mappedCells = summaryCells?.map((cell) => {
              const value = cell.calculateValue ? cell.calculateValue(pageData) : cell.value;
              return (
                <>
                  {cell.label ? (
                    <Table.Summary.Cell align={cell.labelAlign} colSpan={cell.labelColSpan || 1}>
                      {cell.label}
                    </Table.Summary.Cell>
                  ) : null}
                  {summaryColumnPosition >= 2 ? (
                    <Table.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                      {summaryColumnPosition === 2 ? cell.render(value) : null}
                    </Table.Summary.Cell>
                  ) : null}
                  {summaryColumnPosition >= 3 ? (
                    <Table.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                      {summaryColumnPosition === 3 ? cell.render(value) : null}
                    </Table.Summary.Cell>
                  ) : null}
                  {summaryColumnPosition >= 4 ? (
                    <Table.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                      {summaryColumnPosition === 4 ? cell.render(value) : null}
                    </Table.Summary.Cell>
                  ) : null}
                  {summaryColumnPosition >= 5 ? (
                    <Table.Summary.Cell align={cell.valueAlign} colSpan={cell.valueColSpan || 1}>
                      {summaryColumnPosition === 5 ? cell.render(value) : null}
                    </Table.Summary.Cell>
                  ) : null}
                </>
              );
            });

            return (
              <Table.Summary.Row>
                {rowSelection && !disabled ? <Table.Summary.Cell /> : null}
                {mappedCells}
              </Table.Summary.Row>
            );
          }
        ) : null}
      />
      {(!pagination && count > 1) && (
        <Pagination
          page={page}
          setPage={setPage}
          callback={paginationCallback}
          count={count}
        />
      )}
    </React.Fragment>
  );
};

EditableTable.propTypes = {
  cols: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.object),
  mobileCols: PropTypes.arrayOf(PropTypes.object),
  rowSelection: PropTypes.shape({
    selectedRowKeys: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.number),
      PropTypes.arrayOf(PropTypes.string),
    ]),
    type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  editText: PropTypes.string,
  finishText: PropTypes.string,
  cancelText: PropTypes.string,
  noControls: PropTypes.bool,
  controls: PropTypes.shape({
    onClickAdd: PropTypes.func,
    onClickEdit: PropTypes.func,
    onClickExpand: PropTypes.func,
    onClickDelete: PropTypes.func,
    onClickConfig: PropTypes.func,
    onClickFinish: PropTypes.func,
    onClickCancel: PropTypes.func,
  }),
  onRow: PropTypes.func,
  allowEdit: PropTypes.bool,
  allowFinish: PropTypes.bool,
  allowSearch: PropTypes.bool,
  allowCancel: PropTypes.bool,
  expandable: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
  filterNested: PropTypes.bool,
  childrenProp: PropTypes.string,
  RTLHead: PropTypes.bool,
  rowKey: PropTypes.string,
  handleOnRowClick: PropTypes.func,
  pageSize: PropTypes.number,
  disabled: PropTypes.bool,
  allowColumnSelector: PropTypes.bool,
  indentSize: PropTypes.number,
  loading: PropTypes.bool,
  permission: PropTypes.shape({
    add: PropTypes.bool.isRequired,
    authorize: PropTypes.bool.isRequired,
    cancel: PropTypes.bool.isRequired,
    change: PropTypes.bool.isRequired,
    delete: PropTypes.bool.isRequired,
    export: PropTypes.bool.isRequired,
    import: PropTypes.bool.isRequired,
    sync: PropTypes.bool.isRequired,
    view: PropTypes.bool.isRequired,
    hasAllViewPermission: PropTypes.bool.isRequired,
  }),
  hasAllViewPermission: PropTypes.bool,
  pagination: PropTypes.bool,
  paginationCallback: PropTypes.func,
  count: PropTypes.number,
  currentPage: PropTypes.number,
  summaryCells: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    labelAlign: PropTypes.string,
    valueAlign: PropTypes.string,
    labelColSpan: PropTypes.number,
    valueColSpan: PropTypes.number,
    render: PropTypes.func,
    calculateValue: PropTypes.func,
  })),
  summaryColumnPosition: PropTypes.number,
};

EditableTable.defaultProps = {
  mobileCols: [],
  data: [],
  editText: 'Editar',
  finishText: 'Guardar',
  cancelText: 'Cancelar',
  noControls: false,
  controls: null,
  rowSelection: null,
  onRow: null,
  allowEdit: true,
  allowFinish: true,
  allowSearch: true,
  allowCancel: true,
  expandable: null,
  filterNested: false,
  childrenProp: null,
  RTLHead: false,
  rowKey: 'id',
  handleOnRowClick: null,
  pageSize: 10,
  disabled: false,
  allowColumnSelector: true,
  indentSize: 25,
  loading: false,
  permission: null,
  hasAllViewPermission: false,
  pagination: true,
  paginationCallback: null,
  count: 0,
  currentPage: 1,
  summaryCells: null,
  summaryColumnPosition: 2,
};

export default EditableTable;
